var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGambling = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 22,
  height: 20,
  viewBox: "0 0 22 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4 10L6 6V5H3V6H5L3 10M8 10L10 6V5H7V6H9L7 10M12 10L14 6V5H11V6H13L11 10M20 0C18.9 0 18 0.9 18 2C18 2.7 18.4 3.4 19 3.7V15H16V13C16.6 13 17 12.6 17 12V3C17 2.4 16.6 2 16 2H12.2C11.4 0.8 10 0 8.5 0C7 0 5.6 0.8 4.8 2H1C0.4 2 0 2.4 0 3V12C0 12.6 0.4 13 1 13V20H16V17H19C20.1 17 21 16.1 21 15V3.7C21.6 3.4 22 2.7 22 2C22 0.9 21.1 0 20 0ZM2 4H15V11H2V4ZM14 18H3V13H14V18ZM12 17H5V15H12V17Z",
  fill: "#1388DE"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgGambling);
export { ForwardRef as ReactComponent };